import React from "react";
import AccountQualification from "./AccountQualification/AccountQualification";
import AccountLegalStructure from "./AccountLegalStructure/AccountLegalStructure";
import UpdateInfoInstructions from "./UpdateInfoInstructions/UpdateInfoInstructions";

function TrustAccountDetailsGeneralInfo({
  accountNumber,
  dateAdded,
  qualificationLevel,
  verificationStatus,
  trustType,
  setTrustType,
  trustTypeError,
  setTrustTypeError,
  accountName,
  setAccountName,
  accountNameError,
  setAccountNameError,
  countryOfFormation,
  setCountryOfFormation,
  countryOfFormationError,
  setCountryOfFormationError,
}) {
  return (
    <div
      className="container"
      style={{
        maxWidth: "700px",
        paddingTop: "32px",
        paddingBottom: "32px",
        paddingLeft: "16px",
        paddingRight: "16px",
      }}
    >
      <div className="row g-0 w-100">
        <div className="col-12">
          <div className="row g-0 w-100 mb-4">
            <span className="trust-account-section-header-text">
              General Information
            </span>
          </div>
          <AccountQualification
            accountNumber={accountNumber}
            dateAdded={dateAdded}
            qualificationLevel={qualificationLevel}
            verificationStatus={verificationStatus}
          />
          <AccountLegalStructure
            trustType={trustType}
            setTrustType={setTrustType}
            trustTypeError={trustTypeError}
            setTrustTypeError={setTrustTypeError}
            accountName={accountName}
            setAccountName={setAccountName}
            accountNameError={accountNameError}
            setAccountNameError={setAccountNameError}
            countryOfFormation={countryOfFormation}
            setCountryOfFormation={setCountryOfFormation}
            countryOfFormationError={countryOfFormationError}
            setCountryOfFormationError={setCountryOfFormationError}
          />
          <UpdateInfoInstructions />
        </div>
      </div>
    </div>
  );
}
export default TrustAccountDetailsGeneralInfo;
